import { IoIosMore } from "react-icons/io";
import { ClassNames } from "../../utils/ClassNames";
import { useDispatch } from 'react-redux';
import { fetchAgents } from "../../redux/slices/agentSlice";
import { useEffect } from "react";
import Loader from "../Loader";
import ResponsivePagination from 'react-responsive-pagination';


const AgentData = ({ onRowClick, data, itemsPerPage, currentPage, setCurrentPage, isLoading, totalRecord }) => {
  const dispatch = useDispatch()

  const totalPages = Math.ceil(totalRecord / itemsPerPage);
  
  useEffect(() =>{
    setTimeout(() => {
      dispatch(fetchAgents())
    }, 2000);
  }, [dispatch]);

  return (
    <div className="flow-root bg-white mt-6">
        <div className="overflow-x-auto rounded-tr-lg rounded-tl-lg">
          <div className="inline-block min-w-full align-middle">
            <table className="min-w-full divide-y divide-gray-300 table-auto p-4 border">
              <thead className="bg-primaryGray p-1">
                <tr>
                  <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-bold text-black">
                    S/N
                  </th>
                  <th scope="col" className="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-bold capitalize text-black">
                  Delivery Agent Name
                  </th>
                  <th scope="col" className="whitespace-nowrap px-3 py-3.5 text-left text-sm font-bold capitalize text-black">
                  phone number
                  </th>
                  <th scope="col" className="whitespace-nowrap px-3 py-3.5 text-left text-sm font-bold capitalize text-black">
                  ID No
                  </th>
                  <th scope="col" className="whitespace-nowrap px-3 py-3.5 text-left text-sm font-bold capitalize text-black">
                    Active order
                  </th>
                  <th scope="col" className="whitespace-nowrap px-3 py-3.5 text-left text-sm font-bold capitalize text-black">
                    Region Covered
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-bold capitalize text-black">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
              {isLoading ? (
                <div className="grid place-items-center">
                  <Loader />
                </div>
                ) :  data && data.length > 0 ? (
                  <>
                    {data.map((agent, index) =>(
                      <tr key={index} className="border-b border-b-primaryGray cursor-pointer hover:bg-[#F9F9F9]" onClick={() => onRowClick(agent.id)} >
                        <td className="px-3 text-xs text-black capitalize font-medium">{`${index + 1}`}</td>
                        <div className="flex items-center pt-4">
                          <img src={agent.photo} alt="" className="rounded-full h-6 w-6" />
                          <td className="whitespace-nowrap px-3 text-sm text-[#0A0A0A] capitalize font-semibold">{agent.firstName} <span className="ml-1">{agent.lastName}</span></td>
                        </div>
                        <td className="whitespace-nowrap px-3 text-sm text-black italic text-[#0A0A0A]/80 font-semibold capitalize">
                          {agent.phoneNumber}
                        </td>
                        <td className="px-3 text-sm capitalize font-semibold text-[#0A0A0A]">{agent.identityNumber}</td>
                        <td className={`${ClassNames(agent.gender === "male" ? "bg-[#4A90E2] text-white": "bg-orange text-black")} rounded-m inline-block w-1/2 text-center whitespace-nowrap px-3 py-2 mb-2 mx-4 rounded-md text-sm text-black capitalize font-semibold`}>
                          <span className=" rounded-md">{agent.activeOrders}</span></td>
                        <td className="px-3 text-xs capitalize font-semibold text-[#0A0A0A]/80">{agent.regionCovered || "Nil"}</td>
                        <td className="whitespace-nowrap px-3 text-lg py-2 text-[#B3B3B3] flex items-center justify-center">{<IoIosMore />}</td>
                      </tr>
                    ))}
                  </>
              ): (
                <p className="text-sm text-primaryRed text-center py-4" >No Agent available</p>
              )}
              </tbody>
            </table>
            <nav className="grid place-items-center mt-10">
              <ResponsivePagination
                current={currentPage}
                total={totalPages}
                onPageChange={setCurrentPage}
                extraClassName="custom-pagination"
                />
            </nav>
          </div>
        </div>
    </div>
  )
}

export default AgentData